import { graphql } from "@opensea/graphql"
import { PreviewImageFragment } from "./PreviewImage.fragment"

export const PreviewImagesFragment = graphql(
  `
    fragment PreviewImages on Collection {
      about {
        previewMedia {
          ...PreviewImage
        }
      }
    }
  `,
  [PreviewImageFragment],
)
